import { MapContainer, ZoomControl, useMapEvent } from 'react-leaflet'
import LayersRaxione from './LayersRaxione'
import "leaflet/dist/leaflet.css"
import "./Map.css"
import React, { useState, useCallback, useEffect, useReducer, useRef } from 'react';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import { Container, Table, Row, Col, ToggleButton, Stack, Button, Modal, Badge } from 'react-bootstrap';
import styled from 'styled-components';
import jsonCarInfoData from "../data/carinfo.json"
import { useAppContext } from "../libs/contextLib";
import axiosInstance from "../axiosApi";
import config from "../config";
import { onError } from "../libs/errorLib";
import { useTranslation } from 'react-i18next';
import DropdownSelector from "../components/DropdownSelector";
import LoadingSpinner from "../components/LoadingSpinner";
import ToggleSwitch from "../components/ToggleSwitch";
import TechpolMap from '../data/techpol_map.json'

const deg2rad = (deg) => deg * (Math.PI / 180);

const getDistanceFromLatLonInMeters = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c * 1000;
};

function FlyMapTo({ flyToPosition, map, isPopStationInfo, routeMap, inStation, inFlag, getFlag,
                    setInFlag, setInStation, setGetFlag, setModalShow, setStationName }) {
  useEffect(() => {
    if (flyToPosition.lat === 0) return;
    map.flyTo(flyToPosition, 17);
    if (!isPopStationInfo) return;
    let distanceData = 100;
    routeMap.forEach((data) => {
      distanceData = getDistanceFromLatLonInMeters(
        flyToPosition.lat, flyToPosition.lng,
        Number(data.station_lat), Number(data.station_lng)
      );
      if (distanceData <= 50) {
        setInFlag(true);
        setInStation(Number(data.id));
      }
      if (distanceData > 50 && inStation === Number(data.id)) {
        setInFlag(false);
        setGetFlag(false);
        setModalShow(false);
      }
      if (inFlag && !getFlag && inStation === Number(data.id)) {
        console.log('현재 위치에서 대상 위치까지의 거리는 50m 이내에 있습니다.');
        setStationName(data.stationname);
      }
    });
  }, [flyToPosition]);
  return null;
}

const StyledModal = styled(Modal)`
  .modal-content {
    background-color: #E2E4F6;
    border-radius: 50px;
  }
`;

const StyledTable = styled(Table)`
  /* 여기에 원하는 스타일을 추가하세요 */
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  th, td {
    border-bottom: 1px solid #444444;
    padding: 5px;
    text-align: center;
  }
`;

function MyVerticallyCenteredModal(props) {
  const reservations = [
    { id: 1, booker: '2578', route: 'A노선경유지-3', seatnumber: '1', due: 'Now' },
    { id: 2, booker: '2645', route: 'A노선종착지', seatnumber: '2', due: '2024-05-05 15:45' },
    // 다른 예약 정보 추가
  ];

  return (
    <StyledModal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          예약정보
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>정류장 : {props.stationName}</h5>
        <StyledTable striped bordered hover variant="dark">
          <thead>
            <tr>
              <th>예약자</th>
              <th>좌석번호</th>
              <th>경로</th>
              <th>탑승예정</th>
            </tr>
          </thead>
          <tbody>
             {props.routeStops.result == "NOK" ?
                reservations.map((data) => (
                <tr key={data.id}>
                  <td>{data.booker}</td>
                  <td>{data.seatnumber}</td>
                  <td>{data.route}</td>
                  <td>{data.due}</td>
                </tr>
              ))
              :
              <tr key="1">
                <td colSpan={4}>{props.routeStops.message}</td>
              </tr>
            }
          </tbody>
        </StyledTable>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </StyledModal>
  );
}


const carInfoReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_OR_UPDATE':
      const newVehicle = action.payload;
      const existingIndex = state.findIndex(
        (vehicle) => vehicle.vehicle_id === newVehicle.vehicle_id
      );

      if (existingIndex !== -1) {
        // 기존 데이터 업데이트
        const updatedState = [...state];
        updatedState[existingIndex] = {
          ...updatedState[existingIndex],
          ...newVehicle
        };
        return updatedState;
      } else {
        // 새로운 데이터 추가
        return [...state, newVehicle];
      }
    case 'REMOVE':
      return state.filter(
        (vehicle) => vehicle.vehicle_id !== action.payload.vehicle_id
      );
    case 'CLEAR_ALL':
      return [];
    case 'SET_ALL': {
      return action.payload;
    }
    default:
      return state;
  }
};

const MapLeafletRaxione = () => {
  const { t } = useTranslation();
  const [map, setMap] = useState(null);
  //Public API that will echo messages sent to it back to the client
  // const [socketUrl, setSocketUrl] = useState('ws://localhost:8010/ws?userID=ka4_004&type=vehicle');
  const [socketUrl] = useState(`${config.SOCKET_URL}/ws`);
  const [carInfo, dispatcher] = useReducer(carInfoReducer, []);
  const [carInfoLast, setCarInfoLast] = useState(jsonCarInfoData);
  const [onVehicleId, setOnVehicleId] = useState("");
  const {
    routeAppContext, setRouteAppContext,
    carAppContext, setCarAppContext,
    isAuthenticated,
    setCurrentLocation,
  } = useAppContext();
  const carAppContextRef = useRef(carAppContext);
  const [carOptions, setCarOptions] = useState([]);
  const [routeMap, setRouteMap] = useState([{"id":0, "stationname":"소네트(주)", "station_lat":35.692298, "station_lng":128.457914}]);
  const [carList, setCarList] = useState([]);
  const [bookingCarList, setBookingCarList] = useState([]);
  const [bookingCar, setBookingCar] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [routeOptions, setRouteOptions] = useState([]);
  const [position, setPosition] = useState({
    lat: 35.69386,
    lng: 128.45977,
  });
  const [flyToPosition, setFlyToPosition] = useState({
    lat: 35.69386,
    lng: 128.45977,
  });
  const [isSwitchFlyToMap, setIsSwitchFlyToMap] = useState(false);
  const [isPopStationInfo] = useState(false);
  const [isPopVideoInfo, setIsPopVideoInfo] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [routeStops] = useState("");
  const [stationName, setStationName] = useState("");
  const [inFlag, setInFlag] = useState(false);
  const [getFlag, setGetFlag] = useState(false);
  const [inStation, setInStation] = useState(0);
  const [routeId, setRouteId] = useState("1");
  const messageQueueRef = useRef([]);
  const isProcessingRef = useRef(false);
  const [geoJsonData, setGeoJsonData] = useState(TechpolMap);
  const [key, setKey] = useState(0); // GeoJSON 컴포넌트 강제 리렌더링용

  useEffect(() => { setCurrentLocation('/drivingcontrolraxione'); }, []);

  const onSwitchFlyToMap = () => {
    setIsSwitchFlyToMap(!isSwitchFlyToMap);
    //console.log(isSwitchOnService);
  };


  useEffect(() => {
    carAppContextRef.current = carAppContext;
  }, [carAppContext]);

  const addCarInfoHandler = useCallback((carInfo) => {
    dispatcher({ type: 'ADD_OR_UPDATE', payload: carInfo });
  }, []);

  const clearCarInfoHandler = useCallback(() => {
    dispatcher({ type: 'CLEAR_ALL' });
  }, []);


  const {
    sendJsonMessage,
    lastMessage,
    readyState,
  } = useWebSocket(socketUrl, {
    onOpen: () => console.log('opened'),
    shouldReconnect: () => true,
  });

  // 큐를 순차적으로 처리
  const processQueue = useCallback(async () => {
    if (isProcessingRef.current || messageQueueRef.current.length === 0) {
      return;
    }

    isProcessingRef.current = true;

    while (messageQueueRef.current.length > 0) {
      const message = messageQueueRef.current.shift();
      try {
        const jsonLastMessage = JSON.parse(message);
        console.log(jsonLastMessage);
        if (isAuthenticated && routeAppContext.id === jsonLastMessage.data.route_id) {
          addCarInfoHandler(jsonLastMessage.data);
          setOnVehicleId(jsonLastMessage.data.vehicle_id);

          if (jsonLastMessage.data.vehicle_id === carAppContext.vehicle_id) {
            if (!jsonLastMessage.control) {
              jsonLastMessage.control = {
                route_id: jsonLastMessage.data.route_id,
                vehicle_id: jsonLastMessage.data.vehicle_id,
                ome_webrtc: isPopVideoInfo ? "PLAY" : "STOP",
                mode_car_status: "MAN_NORMAL",
                service_car_status: "BKG",
                user_booking_status: "A",
                user_booking_id: 0,
              };
            } else {
              jsonLastMessage.control.ome_webrtc = isPopVideoInfo ? "PLAY" : "STOP";
              if (jsonLastMessage.control.user_booking_id !== 0) {
                const bookingId = Number(jsonLastMessage.control.user_booking_id);
                let result = bookingCarList.find(
                  (option) => Number(option.id) === bookingId
                );
                if (result) {
                  setBookingCar(result);
                  setGeoJsonData(result.mapurl.features[0]);
                } else {
                  axiosInstance.get(`${config.DJANGO_URL}/raxione/bookingcar/`, {
                    params: { route_id: routeAppContext.id, ing_status: 'K' }
                  }).then(function (response) {
                    setBookingCarList(response.data);
                    const refreshed = response.data.find(
                      (option) => Number(option.id) === bookingId
                    );
                    if (refreshed?.mapurl?.features?.[0]) {
                      setBookingCar(refreshed);
                      setGeoJsonData(refreshed.mapurl.features[0]);
                    }
                  }).catch(function (error) {
                    console.error('bookingCarList 재조회 오류:', error);
                  });
                }
              }
            }
            // control이 완전히 세팅된 후 state 업데이트
            setCarInfoLast({ ...jsonLastMessage });
            setFlyToPosition({ lat: Number(jsonLastMessage.data.latitude), lng: Number(jsonLastMessage.data.longitude) });
          }
        }
      } catch (error) {
        console.error('메시지 처리 오류:', error);
      }
    }

    isProcessingRef.current = false;
  }, [isAuthenticated, routeAppContext.id, carAppContext.vehicle_id, isPopVideoInfo, bookingCarList, addCarInfoHandler]);

  useEffect(() => {
    if (lastMessage !== null) {
      if (JSON.parse(lastMessage.data).type === 'raxione') {
        messageQueueRef.current.push(lastMessage.data);
        processQueue();
      }
    }
  }, [lastMessage, processQueue]);

  useEffect(() => {
    if (map && position.lat !== 0) {
      map.flyTo(position, map._zoom);
    }
  }, [position, map]);

  // bookingCar 변경시 Routemap 재조회
  useEffect(() => {
    if (bookingCar) {
      setGeoJsonData(bookingCar.mapurl.features[0]);
      axiosInstance.get(`${config.DJANGO_URL}/raxione/routemap/`, {
          params: { route_id: routeAppContext.id, bookingcar_id: bookingCar.id}
        }).then(function (response) {
          console.log(response.data);
          setRouteMap(response.data);
        }).catch(function (error) {
          console.log(error);
        });
    }
  }, [bookingCar]);

  useEffect(() => {
    setRouteId(routeAppContext.id);
    setIsLoading(true);
    onLoad();
  }, []);

  useEffect(() => {
    if (geoJsonData) {
      setKey(prev => prev + 1);
    }
  }, [geoJsonData]);

  useEffect(() => {
      if (readyState === ReadyState.OPEN && carList.length > 0) {
        console.log("WebSocket is open and carList is available.");
        // console.log(carList);
        if (carList.length > 0) {
          carList.forEach((data) => {
            if (onVehicleId === data.vehicle_id) {
              console.log("현재 탑승 차량과 동일 차량입니다.: " + data.vehicle_id);
            }
          });
        }
      }
    }, [readyState, carList]);

  async function onLoad() {
    console.log('MapLeafletRaxione onLoad');
    try {
      setIsLoading(true);
      setCarOptions([]);
      setCarList([]);
      //console.log(localStorage.getItem('access_token'));
      axiosInstance.get(`${config.DJANGO_URL}/raxione/route/`).then(function(response) {
        //console.log(response.data);
        setRouteOptions(response.data.map( data => ( { name: data.routename, id: data.id, route:data} ) ));

        setPosition({ lat: Number(routeAppContext.ref_lat), lng: Number(routeAppContext.ref_lng) });
        setFlyToPosition({ lat: Number(routeAppContext.ref_lat), lng: Number(routeAppContext.ref_lng) });
        axiosInstance.get(`${config.DJANGO_URL}/raxione/bookingcar/`, {
          params: { route_id: routeAppContext.id, ing_status: 'K'}
        }).then(function (response) {
          // console.log(response.data);
          setBookingCarList(response.data);
          setBookingCar(response.data[0]);
          setGeoJsonData(response.data[0].mapurl.features[0]);
          // console.log(TechpolMap);
          // console.log(response.data[0].mapurl.features[0]);
        }).catch(function (error) {
          console.log(error);
        });
        axiosInstance.get(`${config.DJANGO_URL}/raxione/robocar/`, {
          params: { route_id: routeAppContext.id }
        }).then(function (response) {
          clearCarInfoHandler();
          setCarList(response.data);
          setCarAppContext(response.data[0]);
          response.data.forEach((data) => {
            setCarOptions(carOptions => [...carOptions, { name: data.carname, id: data.id, car: data }]);
          });
        }).catch(function (error) {
          console.log(error);
        });

        setIsLoading(false);
      }).catch(function (error) {
        setIsLoading(false);
        onError(error);
      }); 
    } catch (error) {
      onError(error);
    }
  }

  async function onRefresh(car_id) {
    try {
      setIsLoading(true);
      setPosition({ lat: Number(routeAppContext.ref_lat), lng: Number(routeAppContext.ref_lng) });
      setFlyToPosition({ lat: Number(routeAppContext.ref_lat), lng: Number(routeAppContext.ref_lng) });
      axiosInstance.get(`${config.DJANGO_URL}/raxione/bookingcar/`, {
        params: { route_id: routeAppContext.id, ing_status: 'K'}
      }).then(function (response) {
        // console.log(response.data);
        setBookingCarList(response.data);
        const result = response.data.find(option => Number(option.car.id) === Number(car_id));
        setBookingCar(result);
        setGeoJsonData(result.mapurl.features[0]);
        // console.log(TechpolMap);
        // console.log(response.data[0].mapurl.features[0]);
      }).catch(function (error) {
        console.log(error);
      });

      setIsLoading(false);
    } catch (error) {
      onError(error);
    }
  }

  const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const handleClickSendMessage_ka4_004 = async () => {

    for (let i = 0; i < 1; i++) {
      jsonCarInfoData.type = "raxione"
      jsonCarInfoData.data.route_id = routeAppContext.id
      jsonCarInfoData.data.vehicle_id = carAppContext.vehicle_id;
      jsonCarInfoData.data.speed = Math.floor(Math.random() * 100); 
      jsonCarInfoData.data.latitude = 35.6901;
      jsonCarInfoData.data.longitude = 128.4561;
      jsonCarInfoData.control.user_booking_id = 6; 
      jsonCarInfoData.control.mode_car_status = "AUTO_READY";
      jsonCarInfoData.control.service_car_status = "RDY"; 
      jsonCarInfoData.control.user_booking_status = "B"; 
      // jsonCarInfoData.control.user_booking_id = carInfoLast.control ? carInfoLast.control.user_booking_id : 0; 
      // jsonCarInfoData.control.mode_car_status = carInfoLast.control ? carInfoLast.control.mode_car_status : "MAN_NORMAL";
      // jsonCarInfoData.control.service_car_status = carInfoLast.control ? carInfoLast.control.service_car_status : "BKG"; 
      // jsonCarInfoData.control.user_booking_status = carInfoLast.control ? carInfoLast.control.user_booking_status : "A"; 
      // console.log(jsonCarInfoData);
      sendJsonMessage(jsonCarInfoData)
      await sleep(1000);
    } 
  }

  const handleClickSendMessage_kona_001 = async () => {

    for (let i = 0; i < 1; i++) {
      jsonCarInfoData.type = "raxione"
      jsonCarInfoData.data.route_id = routeAppContext.id
      jsonCarInfoData.data.vehicle_id = "kona_001";
      jsonCarInfoData.data.speed = Math.floor(Math.random() * 100); 
      jsonCarInfoData.data.latitude = 35.691;
      jsonCarInfoData.data.longitude = 128.4557;
      jsonCarInfoData.control.user_booking_id = 16; 
      jsonCarInfoData.control.mode_car_status = "AUTO_READY";
      jsonCarInfoData.control.service_car_status = "RDY"; 
      jsonCarInfoData.control.user_booking_status = "B"; 
      // console.log(jsonCarInfoData);
      sendJsonMessage(jsonCarInfoData)
      await sleep(1000);
    } 
  }

  const handleClickSendMessage_kona_002 = async () => {

    for (let i = 0; i < 600; i++) {
      jsonCarInfoData.type = "raxione"
      jsonCarInfoData.data.route_id = routeAppContext.id
      jsonCarInfoData.data.vehicle_id = "kona_002";
      jsonCarInfoData.data.speed = Math.floor(Math.random() * 100); 
      jsonCarInfoData.data.latitude = 35.6916;
      jsonCarInfoData.data.longitude = 128.4568;
      jsonCarInfoData.control.user_booking_id = 17; 
      jsonCarInfoData.control.mode_car_status = "MAN_NORMAL";
      jsonCarInfoData.control.service_car_status = "BKG"; 
      jsonCarInfoData.control.user_booking_status = "A"; 
      // console.log(jsonCarInfoData);
      sendJsonMessage(jsonCarInfoData)
      await sleep(1000);
    } 
  }

  const handleClickSendMessage_kona_003 = async () => {

    for (let i = 0; i < 600; i++) {
      jsonCarInfoData.type = "raxione"
      jsonCarInfoData.data.route_id = routeAppContext.id
      jsonCarInfoData.data.vehicle_id = "kona_003";
      jsonCarInfoData.data.speed = Math.floor(Math.random() * 100); 
      jsonCarInfoData.data.latitude = 35.6916;
      jsonCarInfoData.data.longitude = 128.4579;
      jsonCarInfoData.control.user_booking_id = 19; 
      jsonCarInfoData.control.mode_car_status = "MAN_NORMAL";
      jsonCarInfoData.control.service_car_status = "BKG"; 
      jsonCarInfoData.control.user_booking_status = "A"; 
      // console.log(jsonCarInfoData);
      sendJsonMessage(jsonCarInfoData)
      await sleep(1000);
    } 
  }

  const handleResetSendMessage = async () => {
    // Go 미들웨어 → gRPC Tick(type='RST')
    // ├─ dispatch_event('service_rst')
    // │       ├─ engine: mark_booking_completed() 호출
    // │       ├─ DB: BookingCar.ing_status = 'Q'
    // │       ├─ vehicle.user_booking_id = None
    // │       └─ 상태 → Operational.Booking.waiting_for_call
    // └─ process_tick() → 이미 waiting_for_call 상태에서 정상 tick 반환
    jsonCarInfoData.type = "raxione"
    jsonCarInfoData.data.route_id = routeAppContext.id
    jsonCarInfoData.data.vehicle_id = carAppContext.vehicle_id;
    jsonCarInfoData.data.speed = Math.floor(Math.random() * 100);
    jsonCarInfoData.data.latitude = Number(carAppContext.site_lat);
    jsonCarInfoData.data.longitude = Number(carAppContext.site_lng);
    jsonCarInfoData.control.user_booking_id = bookingCar ? bookingCar.id : 0; 
    jsonCarInfoData.control.mode_car_status = "MAN_NORMAL";
    jsonCarInfoData.control.service_car_status = "RST"; 
    jsonCarInfoData.control.user_booking_status = "A"; 
    sendJsonMessage(jsonCarInfoData)
    await sleep(3000);
  }


  function onChangeRoute(event) {
    const result = routeOptions.find(option => Number(option.id) === Number(event.target.value));
    if (result) {
      setRouteAppContext(result.route);
      setRouteId(result.route.id);
      setPosition({ lat: Number(result.route.ref_lat), lng: Number(result.route.ref_lng) });
      setFlyToPosition({ lat: Number(result.route.ref_lat), lng: Number(result.route.ref_lng) });
      setOnVehicleId('');
      axiosInstance.get('/raxione/routemap/',{
          params: { route_id: routeAppContext.id, bookingcar_id: bookingCar.id}
      }).then(function(response) {
          setRouteMap(response.data);
      }).catch(function (error) {
          console.log(error);
      });

      axiosInstance.get('/raxione/robocar/', {
        params: { route_id: result.route.id }
      }).then(function (response) {
        clearCarInfoHandler();
        setCarList(response.data);
        setCarAppContext(response.data[0]);
        response.data.map((data) => {
          setCarOptions(carOptions => [...carOptions, { name: data.carname, id: data.id, car: data }]);
        });
      }).catch(function (error) {
        console.log(error);
      });

      //initialize carinfo
      addCarInfoHandler(jsonCarInfoData.data);
    }
  };


  const handleZoomEnd = () => {};

  async function onSelectCar(event) {
    const result = carOptions.find(option => Number(option.id) === Number(event.currentTarget.id));
    setIsPopVideoInfo(false);
    await onRefresh(result.car.id);
    setCarAppContext(result.car);
  }

  return (
    <Stack gap={1}>
      <div className="bg-light border">
        <Container fluid>
          <Row>
            <Col xs={12} md={4}>
                <DropdownSelector
                  labelName={t('FMS_ROUTE')}
                  options={routeOptions}
                  defaultValue={routeId}
                  onChange={onChangeRoute}
                />
            </Col>
            { isAuthenticated ? 
              <>
                <Col xs={12} md="auto">
                  <ToggleSwitch label={t('FMS_CARVIEW')} isChecked={isSwitchFlyToMap} onChange={onSwitchFlyToMap}/>
                </Col>

                {/* <Col xs={12} md="auto">
                  <ToggleSwitch label={t('FMS_CARVIDEO')} isChecked={isPopVideoInfo} onChange={onSwitchPopVideoInfo}/>
                </Col>

                <Col xs={12} md="auto">
                  <ToggleSwitch label={t('FMS_INFOVIEW')} isChecked={isPopStationInfo} onChange={onSwitchPopStationInfo}/>
                </Col>
                
                <Col xs={12} md="auto" style={{ textAlign: 'center', }}>
                    <Button
                      onClick={handleClickSendMessage_kona_001}
                      disabled={readyState !== ReadyState.OPEN}
                      size="sm"
                    >
                      kona_001 {t('FMS_SENDLOCATION')}
                    </Button>
                </Col>
                <Col xs={12} md="auto" style={{ textAlign: 'center', }}>
                    <Button
                      onClick={handleClickSendMessage_kona_002}
                      disabled={readyState !== ReadyState.OPEN}
                      size="sm"
                    >
                      kona_002 {t('FMS_SENDLOCATION')}
                    </Button>
                </Col>
                <Col xs={12} md="auto" style={{ textAlign: 'center', }}>
                    <Button
                      onClick={handleClickSendMessage_kona_003}
                      disabled={readyState !== ReadyState.OPEN}
                      size="sm"
                    >
                      kona_003 {t('FMS_SENDLOCATION')}
                    </Button>
                </Col>
                <Col xs={12} md="auto" style={{ textAlign: 'center', }}>
                    <Button
                      onClick={handleClickSendMessage_ka4_004}
                      disabled={readyState !== ReadyState.OPEN}
                      size="sm"
                    >
                      ka4_004 {t('FMS_SENDLOCATION')}
                    </Button>
                </Col>
                <Col xs={12} md="auto" style={{ textAlign: 'center', }}>
                    <Button
                      onClick={handleClickSendMessage_ka4_004}
                      disabled={readyState !== ReadyState.OPEN}
                      size="sm"
                    >
                      ka4_004 {t('FMS_SENDLOCATION')}
                    </Button>
                </Col>
                */}
                <Col xs={12} md="auto" style={{ textAlign: 'center', }}>
                    <Button
                      onClick={handleResetSendMessage}
                      disabled={readyState !== ReadyState.OPEN}
                      size="sm"
                    >
                      예약 강제종료 처리
                    </Button>
                </Col>
              </> : <Col></Col> }
          </Row>
        </Container>
      </div>
      <div className="bg-light border">
        <Container fluid>
          <Row>
            <Stack direction="horizontal" gap={2}>
              <Button variant="light" disabled>{t('FMS_INFOCAR')}</Button>
              {carList && carList.map((data) => {
                  return (
                    <ToggleButton
                      id={data.id}
                      key={data.id}
                      type="checkbox"
                      variant="outline-primary"
                      value={data.vehicle_id}
                      checked={data.id === carAppContext.id}
                      onChange={(e) => onSelectCar(e)}
                    >
                     <b>{data.carname}</b>
                      { (onVehicleId === data.vehicle_id) ? (
                        <Badge bg="success" className="ms-2">ON</Badge>
                      ) : (
                        <Badge bg="danger" className="ms-2">OFF</Badge>
                      )
                      }
                    </ToggleButton>
                  
                    );
              })}
            </Stack>
          </Row>
        </Container>
      </div>
      <div className="bg-light border">
        {isLoading ? <LoadingSpinner /> : ""}
        <MapContainer
          center={{
            lat: Number(routeAppContext.ref_lat),
            lng: Number(routeAppContext.ref_lng),
          }}
          zoom={Number(routeAppContext.defalt_zoom)}
          style={{ height: '85vh', width: '100%' }}
          ref={setMap}
          zoomControl={false}
          scrollWheelZoom={true}
        >
          <LayersRaxione geoJsonKey={key} geoJsonData={geoJsonData} routeMap={routeMap} carInfo={carInfo} carInfoLast={carInfoLast} map={map} isPopVideoInfo={isPopVideoInfo} />
          <ZoomControl position='topright' />
          <ZoomEventHandlers handleZoomEnd={handleZoomEnd} />
          {isSwitchFlyToMap && (
            <FlyMapTo
              flyToPosition={flyToPosition}
              map={map}
              isPopStationInfo={isPopStationInfo}
              routeMap={routeMap}
              inStation={inStation}
              inFlag={inFlag}
              getFlag={getFlag}
              setInFlag={setInFlag}
              setInStation={setInStation}
              setGetFlag={setGetFlag}
              setModalShow={setModalShow}
              setStationName={setStationName}
            />
          )}
        </MapContainer>
      </div>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        stationName={stationName}
        routeStops={routeStops}
      />
    </Stack>
  )
}

const ZoomEventHandlers = ({ handleZoomEnd }) => {
  useMapEvent('zoomend', handleZoomEnd);
  return null;
};

export default MapLeafletRaxione